<template>
  <div class="top-hero1" :class="{ loading: loading }">
    <!-- <video :src="video" autoplay muted loop type="video/mp4"></video> -->

    <div class="container">
      <!-- <div id="challange-target">hidden</div> -->

      <div class="row">
        <main
          v-show="inventory == ''"
          class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24"
        >
          <div class="text-center">
            <h1
              style="background: rgb(255,255,255); background: linear-gradient(163deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.1) 100%);"
              class=" p-4 rounded-md tracking-tight font-extrabold text-gray-900 text-7xl"
            >
              <span class="text-gray-100 block xl:inline">360 Real Estate</span>
              <span class="block text-blue-400 xl:inline">Rentals</span>
            </h1>
            <p
              class="mt-3 max-w-md mx-auto text-base text-gray-50 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
            >
              <span class="text-4xl font-extrabold">
                All Rentals are currently occupied!
              </span>
            </p>

            <div class="mt-4">
              <h3 class="display-1 text-white">Need property management?</h3>
              <div class="max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
                <div class="rounded-md shadow">
                  <a
                    @click="contact"
                    href="#"
                    class="w-full flex items-center justify-center px-8 py-3  text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10"
                  >
                    Contact 360 Real Estate
                  </a>
                </div>
              </div>
            </div>

            <div class="mt-6 py-6 mb-4">
              <p class="display-1 text-white py-4">
                <span class="py-4"
                  >Having trouble finding a rental in this market?</span
                >
                <span class="py-4">Have you considered buying a home?</span>
                <span class="py-4"
                  >Click below to learn more about the process.</span
                >
              </p>
              <div class="max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
                <div class="rounded-md shadow">
                  <div
                    @click="isBuyer()"
                    class="cursor-pointer flex flex-col rounded-lg shadow-2xl overflow-hidden transform transition duration-500 hover:scale-110"
                  >
                    <div class="flex-shrink-0 animate-pulse">
                      <img
                        class="h-48 w-full object-contain bg-white"
                        src="../assets/rental.png"
                        alt=""
                      />
                    </div>
                    <div
                      class="flex-1 bg-white p-6 flex flex-col justify-between"
                    >
                      <div class="flex-1">
                        <a class="block mt-2">
                          <p class="text-xl font-semibold text-gray-900">
                            Buy a Home
                          </p>
                          <ul
                            style="list-style-type:disc; line-height: 2em;"
                            class="mt-3 text-base text-gray-500"
                          >
                            <li>
                              Local area EXPERTS able to get you the best deal!
                            </li>
                            <li>
                              Professional negotiations and contract services
                            </li>
                            <li>
                              Well versed with various loan types - including VA
                              loans!
                            </li>
                          </ul>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <div class="col-md-12" v-show="response != ''">
          <div v-if="response != ''">
            <div
              class="alert alert-success alert-dismissible fade show"
              role="alert"
            >
              <strong>Results Found! {{ inventory.length }}</strong>
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

          <div v-else>
            <div
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              <strong>No search results</strong> Please try different values.
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-4" v-for="rental in inventory" :key="rental.id">
          <v-hover v-slot:default="{ hover }">
            <v-card
              style="border-radius: 10px;"
              class="mx-auto"
              color="grey lighten-4"
              max-width="550"
            >
              <sequential-entrance tag="section">
                <v-img
                  :aspect-ratio="16 / 9"
                  :src="rental.images[0].image_path"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                      style="height: 100%;"
                    >
                      <v-btn depressed :href="rental.rental_application_path">
                        Apply Now!
                      </v-btn>
                    </div>
                  </v-expand-transition>
                </v-img>
              </sequential-entrance>
              <v-card-text class="pt-6" style="position: relative;">
                <v-btn
                  @click="redirect(rental)"
                  absolute
                  color="blue"
                  class="white--text"
                  fab
                  large
                  right
                  top
                >
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-btn>
                <div class="font-weight-light grey--text title mb-2">
                  {{ rental.title }}
                </div>

                <h3 class="display-1 font-weight-light blue--text mb-2">
                  {{ rental.address }}
                </h3>
                <div class="font-weight-light title mb-2">
                  <small><b>Included Items:</b></small
                  ><br />
                  {{ rental.included_items }}
                </div>
                <v-divider></v-divider>
                <div>
                  <v-chip class="mr-2">
                    <v-icon left> mdi-brightness-5 </v-icon>
                    City: {{ rental.city }}
                  </v-chip>

                  <v-chip class="mr-2">
                    <v-icon left> mdi-brightness-5 </v-icon>
                    Bathroom: {{ rental.bathroom }}
                  </v-chip>

                  <v-chip class="mr-2">
                    <v-icon left> mdi-brightness-5 </v-icon>
                    Bedroom: {{ rental.bedroom }}
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </div>
      </div>
      <!-- /.row -->
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
export default {
  data() {
    return {
      loading: true,
      video: "https://homesby360.s3.amazonaws.com/homesBy.mp4",
      inventory: [],
      checked: "",
      search: "",
      response: false,
      dateSelected: new Date().toISOString().substr(0, 10)
    };
  },

  created() {
    this.getInventory();
  },

  mounted() {
    if (this.$route.params.value == "true") {
      fetch("https://api.ipify.org?format=json")
        .then(x => x.json())

        .then(({ ip }) => {
          setTimeout(() => {
            window.axios
              .post("api/geoRent", { rawIp: ip, tagId: 4 })
              .then(res => {
                console.log(res.data);
                this.$route.params.value = "false";
              });
          }, 10000);
        });
    }
  },

  methods: {
    modalSearch() {
      $("#imageUp").modal("show");
    },

    searching() {
      window.axios
        .post("/api/rentalPriceRes", {
          queryResult: this.search
        })
        .then(res => {
          this.response = true;
          this.inventory = res.data;
        });
    },

    searchAvailable() {
      window.axios
        .post("/api/rentalAvailableRes", {
          queryResult: this.dateSelected
        })
        .then(res => {
          this.response = true;
          this.inventory = res.data;
        });
    },

    getInventory() {
      window.axios.get("/api/rentals").then(res => {
        this.inventory = res.data;
        this.loading = false;
      });
    },

    redirect(rental) {
      this.$router.push({ name: "Rental", params: { id: rental.id } });
    },

    contact() {
      this.$router.push({ name: "Contact" });
    },

    isBuyer() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "BuyerRegister",
          params: { state: "Buyer" }
        });
      }
    }
  }
};
</script>

<style scoped>
video {
  background-color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.02;
  pointer-events: none;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

#hidden-search {
  display: inline;
}

@media (max-width: 1026px) {
  #hidden-search {
    display: none;
  }
}

.float {
  position: fixed;
  width: 60px;
  height: 60px;
  top: 80px;
  right: 40px;
  background-color: #0c9;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.my-float {
  margin-top: 22px;
}

.bg-image {
  background-color: #fafafa;
  background-image: url("https://revistaaxxis.com.co/wp-content/uploads/2019/09/llano-axxis1.jpg");
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 1000;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255);
  /* background-color: rgba(0,0,0,0.3); */
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
